import { Notification } from '@progress/kendo-react-notification';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { removeNotificationMessage } from '../../redux/slices/appStateSlice';

interface SingleNotificationProps{
  style: any;
  text: string;
  timeout: number;
}

export default function SingleNotification(props: SingleNotificationProps) {
  const [visible, setVisible] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      dispatch(removeNotificationMessage());
    }, props.timeout);
    return () => clearTimeout(timer);
  }, [props.timeout, dispatch]);

  return (
    visible && (
      <Notification
        type={{ style: props.style, icon: true }}
        closable={true}
        onClose={() => setVisible(false)}
      >
        {props.text}
      </Notification>
    )
  );
}
